const KEY = 'ENROLL';
const EVENT_KEY = [KEY, 'EVENT'];
const USER_KEY = 'ENROLL-USER';
const CANDIDATE_KEY = [KEY, 'USER-CANDIDATE'];
const SUMMARY_KEY = [KEY, 'SUMMARY'];
const SUMMARY_EVENT_KEY = [KEY, 'EVENT-SUMMARY'];

export {
  KEY,
  EVENT_KEY,
  USER_KEY,
  CANDIDATE_KEY,
  SUMMARY_KEY,
  SUMMARY_EVENT_KEY,
};
